// header mega menu mous hover open js
const megaMenuDetails = document.querySelectorAll('.mega-menu');
megaMenuDetails.forEach((menu) => {
  let timer; 
  menu.addEventListener('mouseenter', () => {
    clearTimeout(timer); 
    timer = setTimeout(() => {
      menu.setAttribute('open', '');
    }, 500); 
  });
  menu.addEventListener('mouseleave', () => {
    clearTimeout(timer); 
    timer = setTimeout(() => {
      menu.removeAttribute('open');
    }, 500);
  });
});


// footer mobile
document.addEventListener("DOMContentLoaded", () => {
  const footerBlocks = document.querySelectorAll(".footer-block");
  footerBlocks.forEach((block) => {
    const heading = block.querySelector(".footer-block__heading");
    const menu = block.querySelector(".footer-block__details-content");
    const toggleIcon = block.querySelector(".toggle-icon");

    heading.addEventListener("click", () => {
      menu.classList.toggle("active"); 
      toggleIcon.classList.toggle("rotate"); 
    });
  });
});